import { getAssignedDataGroup } from "core/router/auth";
import { ResourceName } from "core/router/config/ResourceName";
import { baseAuthApi } from "core/service/baseApi";
import type { Dto } from "core/types/be/Dto";

import { PromptDataDtoToEntity } from "src/app/features/ApplicationProfile/subFeatures/PromptData/services/mappers/PromptDataDtoToEntity";
import { PromptDataEntityToDto } from "src/app/features/ApplicationProfile/subFeatures/PromptData/services/mappers/PromptDataEntityToDto";
import type { PromptDataEntity } from "../../types/PromptDataEntity";
import type { PromptDataEntityObject, PromptDataQueryParams } from "./PromptDataQueryTypes";

const PromptDataApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        PromptDataLoad: builder.query<PromptDataEntity, PromptDataQueryParams>({
            providesTags: [ResourceName.APPLICATION_PROFILE_PROMPT_DATA],
            query: (promptDataQueryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}/${promptDataQueryParams.appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION}/${promptDataQueryParams.cardProfId}/${ResourceName.APPLICATION_PROFILE_PROMPT_DATA}/${promptDataQueryParams.id}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return PromptDataDtoToEntity(response);
            },
        }),
        PromptDataSave: builder.mutation<PromptDataEntity, PromptDataEntityObject>({
            query: ({ promptDataFormData, promptDataQuery }) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}/${promptDataQuery.appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION}/${promptDataQuery.cardProfId}/${ResourceName.APPLICATION_PROFILE_PROMPT_DATA}`;
                const method = "POST";

                const body = PromptDataEntityToDto(promptDataFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.APPLICATION_PROFILE_PROMPT_DATA],
        }),
        PromptDataUpdate: builder.mutation<PromptDataEntity, PromptDataEntityObject>({
            query: ({ promptDataFormData, promptDataQuery }) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}/${promptDataQuery.appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION}/${promptDataQuery.cardProfId}/${ResourceName.APPLICATION_PROFILE_PROMPT_DATA}/${promptDataQuery.id}`;
                const method = "PUT";

                const body = PromptDataEntityToDto(promptDataFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.APPLICATION_PROFILE_PROMPT_DATA],
        }),
        PromptDataDelete: builder.mutation<PromptDataEntity, PromptDataQueryParams>({
            query: (promptDataQueryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}/${promptDataQueryParams.appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION}/${promptDataQueryParams.cardProfId}/${ResourceName.APPLICATION_PROFILE_PROMPT_DATA}/${promptDataQueryParams.id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: [ResourceName.APPLICATION_PROFILE_PROMPT_DATA],
        }),
    }),
});

export const { usePromptDataLoadQuery, usePromptDataSaveMutation, usePromptDataUpdateMutation, usePromptDataDeleteMutation } =
    PromptDataApi;
